export const config = {
    apiKey: "AIzaSyCsDXcBqUkFzP7a_YLfSi1bUFV4zYv9Ipk",
    authDomain: "instagram-clone-21d9b.firebaseapp.com",
    databaseURL: "https://instagram-clone-21d9b.firebaseio.com",
    projectId: "instagram-clone-21d9b",
    storageBucket: "instagram-clone-21d9b.appspot.com",
    messagingSenderId: "766234567722",
    appId: "1:766234567722:web:6715c7b7dcae914e950f53",
    measurementId: "G-770BEE44CM"
}
export const anonInfo = {
    email: "anonymous@gmail.com",
    pass: "428273Mb"
}

export const lastFMKey = "c97bb1d27fa8605e3980c6ad761e0648";
export const recaptchaSitekey = "6LfuKB0qAAAAACz3LvWwPjoIlzgWZ2NBxx0Jz2vY";

export const extraCurseWords = [
    "hoe",
    "piss",
    "bullshit",
    "fatherfucker",
    "horseshit",
    "bollocks",
    "nigra",
    "spastic"
];

// ----- Firestore database rules ------

// OLD

// rules_version = '2';
// service cloud.firestore {
//   match /databases/{database}/documents {
//   match /{document=**} {
//       allow read : if request.auth.uid != null;
//       allow write : if request.auth.uid != null;
//     }
//   }
  

//     match /users/{usersId} {
//       allow create: if request.auth.uid != null;
//     	allow read : if request.auth.uid  == usersId;
//     	allow write: if request.auth.uid == usersId;
//     }
//   }

// NEW

// rules_version = '2';
// service cloud.firestore {
//   match /databases/{database}/documents {
//   match /{document=**} {
//       allow read ;
//       allow write : if request.auth.uid != null;
//     }
//   }
  

//     match /users/{usersId} {
//       allow create: if request.auth.uid != null;
//     	allow read : if request.auth.uid  == usersId;
//     	allow write: if request.auth.uid == usersId;
//     }
// }


// ----x-x---- end of Firebase database rules -----xx-------
// ------- Firebase realtime db rules -----------

// /{
//   "rules": {
//     "status": {
//           ".read": "auth.uid != null",
//    	 			".write": "auth.uid != null",
//     },
//     "rating": {
//           ".read": "auth.uid != null",
//    	 			".write": "auth.uid != null",
//     },
//     "userNames":{
//       	".read":"true",
//         ".write": "true"
//     }

//   }
// }

// ----xx---- end of Firebase realtime db rules -----xx------

// -------- Firebase storage rules --------

// rules_version = '2';
// service firebase.storage {
//   match /b/{bucket}/o {
//     match /{allPaths=**} {
//      allow write: if request.auth != null;
// 		 allow read: if true;
//     }
//   }
// }

// ----xx---- end of Firebase storage rules -----xx------

// recaptcha keys

//export const secretkey = "6LfuKB0qAAAAAEYOghCaG04tTPqg6tCvDIDbJnT2"